/** Буква-аватар ассистента: первая значимая буква названия, цвет — по названию. */

const PALETTE = [
  { bg: '#EFF6FF', fg: '#2563EB' },
  { bg: '#FFF7ED', fg: '#C2410C' },
  { bg: '#ECFDF5', fg: '#047857' },
  { bg: '#F5F3FF', fg: '#6D28D9' },
  { bg: '#FDF2F8', fg: '#BE185D' },
  { bg: '#F3F4F6', fg: '#374151' },
];

/** «Сервисный центр «КофеСервис»» → «К»: берём слово в кавычках, если есть. */
export function avatarLetter(name: string): string {
  const quoted = /[«"„]([^»"“]+)[»"“]/.exec(name);
  const src = (quoted?.[1] ?? name).trim();
  const ch = src.match(/[\p{L}\p{N}]/u)?.[0] ?? '?';
  return ch.toUpperCase();
}

/** Короткое имя для меню: слово в кавычках («КофеСервис») или полное название. */
export function shortName(name: string): string {
  const quoted = /[«"„]([^»"“]+)[»"“]/.exec(name);
  return (quoted?.[1] ?? name).trim();
}

export function avatarColors(key: string) {
  let h = 0;
  for (let i = 0; i < key.length; i += 1) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

interface Props {
  name: string;
  /** Ключ для цвета (обычно id ассистента), чтобы цвет не менялся при переименовании. */
  colorKey?: string;
  size?: number;
}

export function LetterAvatar({ name, colorKey, size = 26 }: Props) {
  const c = avatarColors(colorKey ?? name);
  return (
    <span
      className="v2-avatar"
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        background: c.bg,
        color: c.fg,
        fontSize: size >= 30 ? 13 : 12,
        borderRadius: size >= 28 ? 8 : 7,
      }}
    >
      {avatarLetter(name)}
    </span>
  );
}
